import React from 'react';

import { Skeleton } from '@mui/material';

import { CardSkeletonLines, CardSkeletonRow } from './styled-components';

// Brand loading placeholder that mirrors a candidate card (avatar + two text
// lines). Decorative — the surrounding region carries the loading status, so it
// is hidden from assistive tech.
export const CardSkeleton: React.FC = () => (
  <CardSkeletonRow aria-hidden>
    <Skeleton height="2.25rem" variant="circular" width="2.25rem" />

    <CardSkeletonLines>
      <Skeleton variant="text" width="60%" />

      <Skeleton variant="text" width="40%" />
    </CardSkeletonLines>
  </CardSkeletonRow>
);
